import { BulkGroupItem } from '../control-panel/pricing-management/bulk-pricing/bulk-group-mgmt/bulk-group-interface';
import { Issuer, PotentialIssuer } from '../issuer-interface';
import { ControlItem } from '../../../interfaces/interface';

export class TogglePricingMode {
  static readonly type = '[Issuer] Toggle Pricing Mode';
  constructor(public isBulk?: boolean) {}
}

export class ToggleEditMode {
  static readonly type = '[Issuer] Toggle Edit Mode';
  constructor(public isEdit?: boolean) {}
}

export class SetSelectedEntity {
  static readonly type = '[Issuer] Set Selected Entity';
  constructor(public selectedEntity: PotentialIssuer | BulkGroupItem) {}
}

export class SetSelectedPricingSource {
  static readonly type = '[Issuer] Set Selected Pricing Source';
  constructor(public selectedPricingSource: ControlItem) {}
}

export class SetBulkNoteOverrideFlag {
  static readonly type = '[Issuer] Set Bulk Note Override Flag';
  constructor(public isBulkNoteOverrideEnabled: boolean) {}
}

export class AddIssuers {
  static readonly type = '[Issuer] Add Issuers';
  constructor(public issuers: Issuer[]) {}
}

export class FetchCountries {
  static readonly type = '[Issuer] Fetch Countries';
}

export class FetchIssuers {
  static readonly type = '[Issuer] Fetch Issuers';
}

export class FetchSectors {
  static readonly type = '[Issuer] Fetch Sectors';
}

export class FetchRatings {
  static readonly type = '[Issuer] Fetch Ratings';
}

export class FetchCurrencies {
  static readonly type = '[Issuer] Fetch Currencies';
}

export class FetchLookupCodes {
  static readonly type = '[Issuer] Fetch Lookup Codes';
}

export class UpdateIssuerIsPreviouslyPriced {
  static readonly type = '[Issuer] Update Issuer Is Previously Priced';
}

export class FetchSelectedIssuerCurrencies {
  static readonly type = '[Issuer] Fetch Selected Issuer Currencies';
  constructor(public issuerId: number) {}
}